import { Address } from 'nftx.js';
import { useMemo } from 'react';
import useLiquidityPools from './useLiquidityPools';

const useLiquidityPool = (poolAddress?: Address) => {
  const {
    data: pools,
    status,
    error,
  } = useLiquidityPools(
    { poolIds: poolAddress ? [poolAddress] : undefined },
    { enabled: !!poolAddress }
  );

  const pool = useMemo(() => {
    return pools?.[0];
  }, [pools]);

  return { status, error, data: pool };
};

export default useLiquidityPool;
